import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ServerApi } from '@services/server-api';

import { extractResponseBody } from '@lib/utils';

export interface ICompany {
  id: number;
  companyId: string;
  name: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  driverCount: number;
  vehicleCount: number;
  assetCount: number;
  selected: boolean;
}

export interface IResponseCompany {
  company: {
    id: number;
    company_id: string;
    name: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    driver_count: number;
    vehicle_count: number;
    asset_count: number;
    selected: boolean;
  };
}

interface IGetCompaniesServerResponse {
  companies: IResponseCompany[];
}

@Injectable()
export class CompanySwitcherService {
  private canSwitchCompanyInner = false;

  public get canSwitchCompany(): boolean {
    return this.canSwitchCompanyInner;
  }

  constructor(
    private api: ServerApi,
  ) {}

  public getCompanies (): Observable<ICompany[]> {
    return this.api
      .get<IGetCompaniesServerResponse>('users/shared_companies')
      .pipe(
        map(extractResponseBody),
        map(this.transformData),
        tap((list: ICompany[]) => this.canSwitchCompanyInner = list.length > 1),
      );
  }

  public switchCompany (companyId: number): Observable<string> {
    const data: { company_id: number } = {
      company_id: companyId,
    };

    return this.api.post('sessions/switch_company', data)
      .pipe(
        map(extractResponseBody),
        map((response: { token: string }): string => response.token),
      );
  }

  private transformData (data: IGetCompaniesServerResponse): ICompany[] {
    return data.companies.map(({ company }: IResponseCompany) => {
      return {
        id: company.id,
        companyId: company.company_id,
        name: company.name,
        street: company.street,
        city: company.city,
        state: company.state,
        zip: company.zip,
        driverCount: company.driver_count,
        vehicleCount: company.vehicle_count,
        assetCount: company.asset_count,
        selected: company.selected,
      };
    });
  }
}
